import { StartClassificationAndExtractionResponse } from "@dune/types";
import { getErrorMessage } from "@dune/vars";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { privateAxios } from "../axios";

const startClassificationAndExtraction = async (fileIds: string[]) => {
	const { data } =
		await privateAxios.post<StartClassificationAndExtractionResponse>(
			"/ai-jobs/start-classification-and-extraction",
			fileIds,
		);
	return data;
};

export const useStartClassificationAndExtraction = (
	options?: UseMutationOptions<
		StartClassificationAndExtractionResponse,
		Error,
		unknown
	>,
) => {
	return useMutation({
		mutationFn: startClassificationAndExtraction,
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors du démarrage des traitements", {
				description: errorMessage,
			});
		},
		...options,
	});
};
